import $ from 'jquery';
import {getSetting} from '@wc-stripe/utils';
import AbstractCheckoutController from './AbstractCheckoutController';

class AddPaymentMethodController extends AbstractCheckoutController {

    initActions() {
        this.actions.addAction('payment_method_selected', this.onPaymentMethodSelected.bind(this));
        $(document.body).on('click', '#place_order', this.onPlaceOrderClick.bind(this));
    }

    onPaymentElementReady() {
        super.onPaymentElementReady();
        this.triggerPaymentMethodSelected();
    }

    async onPlaceOrderClick(e) {
        if (!this.isPaymentGatewaySelected()) {
            return;
        }
        e.preventDefault();

        try {
            await this.gateway.validatePaymentElement();
        } catch (error) {
            return this.submitError(error);
        }
        await this.createPaymentMethod();
    }

    async submit(checkoutData = null) {
        if (this.gateway.supports('payment_sheet')) {
            this.hidePaymentElement();
            this.displayPlaceOrderButton();
        }
        await this.createSetupIntent();
    }

    submitError(error) {
        super.submitError(error);
        if (this.gateway.supports('payment_sheet')) {
            this.displayPaymentElement();
            this.hidePlaceOrderButton();
        }
    }

    submitForm() {
        this.getForm().trigger('submit');
    }

    isPaymentMethodAvailable() {
        const paymentMethods = getSetting('paymentMethods');
        return paymentMethods?.[this.gateway.id]?.supports?.includes('add_payment_method') ?? false;
    }

    needsShipping() {
        return false;
    }
}

export default AddPaymentMethodController;